import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import TableWidget from "../../components/tables/TableWidget";
import FormHeader from "../../components/misc/FormHeader";
import { generalRoutes } from "../../router/routesConstants";
import {
  awbHistoryTableHeader,
  getAwbTableData,
} from "./components/tableConfigs/awbHistoryTableConfig";
import { TableActions } from "../../components/tables/tableContext/TableContext";
import { fetchAwbHistory } from "../../redux/api/general.api";
import AwbHistoryActionButtons from "./components/ActionButtons/AwbHistoryActionButton";
import { getAwbStatuses } from "../../redux/api/expedition.api";

function AwbHistoryTable() {
  const dispatch = useAppDispatch();

  const {
    general: {
      awbHistory: {
        data: { data: dataAwb, total: totalAwb },
        isLoading: isLoadingAwb,
      },
    },
    expedition: {
      workingRoutesNodes: {
        data: { data: clientsNodesData },
        isLoading: isLoadingNodes,
      },
      awbStatuses: { data: awbStatusesData, isLoading: isLoadingAwbStatus },
    },
  } = useAppSelector((state) => ({
    general: state.general,
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(getAwbStatuses());
  }, [dispatch]);

  const awbHistoryTableHeaderNew = useMemo(
    () =>
      awbHistoryTableHeader.map((item) => {
        if (!isLoadingNodes && item.value === "nodDestinatie") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        if (!isLoadingAwbStatus && item.value === "status") {
          const awbStatusesDropdown = awbStatusesData?.map(
            ({ denumire, valoare }) => ({
              label: denumire,
              value: valoare,
            }),
          );
          return {
            withFilter: [
              { label: "Toate", value: "all" },
              ...awbStatusesDropdown,
            ],
            ...item,
          };
        }
        return item;
      }),

    [awbStatusesData, clientsNodesData, isLoadingAwbStatus, isLoadingNodes],
  );

  const handleAwbTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch &&
      action.tableFilter
    ) {
      dispatch(
        fetchAwbHistory({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          pctlivrare: action.tableSearch.pctlivrare,
          nodDestinatie: action.tableFilter.nodDestinatie,
          status: action.tableFilter.status,
          doc_trans: action.tableSearch.doc_trans,
        }),
      );
    }
  };

  return (
    <TableWidget
      CustomHeaderComponent={() => (
        <FormHeader
          title="Istoric expeditii"
          buttonIcon="ADD"
          buttonRoute={`/${generalRoutes.createAwb}`}
          buttonTooltip="Plaseaza comanda"
        />
      )}
      tableHeaderData={awbHistoryTableHeaderNew}
      tableItemsData={getAwbTableData(dataAwb)}
      totalItems={totalAwb}
      tableLoading={isLoadingAwb}
      handleTableActions={handleAwbTableActions}
      ActionButtonsComponent={(props: any) => (
        <AwbHistoryActionButtons {...props} />
      )}
      borderedRow
    />
  );
}

export default AwbHistoryTable;
